const actions = {
    FETCH_ROUTINES: 'FETCH_ROUTINES',
    FETCH_ROUTINES_SUCCESS: 'FETCH_ROUTINES_SUCCESS',
    FETCH_ROUTINES_FAIL: 'FETCH_ROUTINES_FAIL',

    POST_ROUTINE: 'POST_ROUTINE',
    POST_ROUTINE_SUCCESS: 'POST_ROUTINE_SUCCESS',
    POST_ROUTINE_FAIL: 'POST_ROUTINE_FAIL',

    UPDATE_ROUTINE: 'UPDATE_ROUTINE',
    UPDATE_ROUTINE_SUCCESS: 'UPDATE_ROUTINE_SUCCESS',
    UPDATE_ROUTINE_FAIL: 'UPDATE_ROUTINE_FAIL',

    DELETE_ROUTINE: 'DELETE_ROUTINE',
    DELETE_ROUTINE_SUCCESS: 'DELETE_ROUTINE_SUCCESS',
    DELETE_ROUTINE_FAIL: 'DELETE_ROUTINE_FAIL',

    SET_ACTIVE_ROUTINE: 'SET_ACTIVE_ROUTINE',

    ADD_ROUTINE_EXERCISE: 'ADD_ROUTINE_EXERCISE',

    DELETE_ROUTINE_EXERCISE: 'DELETE_ROUTINE_EXERCISE',

    POST_ROUTINE_EXERCISES: "POST_ROUTINE_EXERCISES",
    POST_ROUTINE_EXERCISES_SUCCESS: "POST_ROUTINE_EXERCISES_SUCCESS",
    POST_ROUTINE_EXERCISES_FAIL: "POST_ROUTINE_EXERCISES_FAIL",

    OPEN_ROUTINE_DIALOG: 'OPEN_ROUTINE_DIALOG',
    CLOSE_ROUTINE_DIALOG: 'CLOSE_ROUTINE_DIALOG',
    OPEN_TRAINING_DIALOG: 'OPEN_TRAINING_DIALOG',
    CLOSE_TRAINING_DIALOG: 'CLOSE_TRAINING_DIALOG',
}

export default actions